import { toast } from 'react-toastify'

export const handleHookFormErrors = (errors: any) => {
  const errorMessages: string[] = []

  Object.keys(errors).forEach((key) => {
    if (errors[key]?.message) {
      errorMessages.push(errors[key].message)
    } else if (typeof errors[key] === 'object') {
      Object.keys(errors[key]).forEach((subKey) => {
        if (errors[key][subKey]?.message) {
          errorMessages.push(errors[key][subKey].message)
        }
      })
    }
  })

  if (errorMessages.length) {
    errorMessages.forEach((msg) => toast.error(msg))
  } else {
    toast.error('Validation failed. Please check your input.')
  }
}
